import { useContext, useEffect, useState } from "react";
import { Link, useMatch, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Spinner from "../../components/BootstrapCompo";
import { GlobalContext, handleError } from "../../context/Provider";
import henceforthApi from "../../utils/henceforthApi";

const EditDocumentType = () => {
    const match = useMatch("/document-types/:id/edit");
    const { loading, setLoading, authState } = useContext(GlobalContext);
    const navigate = useNavigate();

    const [form, setForm] = useState({
        resource: "",
        name: "",
        description: "",
        status: "",
        sides_required: ""
    });
    const [errors, setErrors] = useState<{ [key: string]: string }>({});

    const fetchDetail = async () => {
        setLoading(true);
        try {
            const res = await henceforthApi.DocumentType.getDetail(match?.params.id || '');
            const data = res.data;
            setForm({
                resource: data.resource || "SELLER",
                name: data.name || "",
                description: data.description || "",
                status: data.status || "ACTIVE",
                sides_required: data.sides_required || "BOTH"
            });
        } catch (error) {
            handleError(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDetail();
    }, [match?.params.id, authState?.lang]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
        if (errors[name]) setErrors({ ...errors, [name]: "" });
    };

    const validate = () => {
        const newErrors: { [key: string]: string } = {};
        if (!form.name.trim()) newErrors.name = "Name is required";
        return newErrors;
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length) {
            setErrors(validationErrors);
            return;
        }

        setLoading(true);
        try {
            await henceforthApi.DocumentType.edit(match?.params.id || '', form);
            toast.success("Document type updated successfully");
            navigate("/document-types/1");
        } catch (error) {
            handleError(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <section className="breadcrum-box">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <h2 className="fw-semibold">Edit Document Type</h2>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/document-types/1">Document Types</Link></li>
                                    <li className="breadcrumb-item active fw-bold">Edit</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </section>

            <div className='page-spacing'>
                <section className='product-detail'>
                    <div className="container-fluid">
                        <div className="row justify-content-center">
                            <div className="col-sm-10 col-md-6 col-lg-5 col-xl-4 col-xxl-3">
                                <div className="common-card">
                                    <div className="common-card-title">
                                        <h5>Edit Document Type</h5>
                                    </div>
                                    <div className="common-card-content">
                                        {loading ? (
                                            <div className="text-center py-4"><Spinner /></div>
                                        ) : (
                                            <form onSubmit={handleSubmit}>
                                                {/* Resource (read-only) */}
                                                <div className="form-fields-box mb-3">
                                                    <label className="mb-1 fw-bold">Resource</label>
                                                    <select
                                                        name="resource"
                                                        className="form-select rounded-0"
                                                        value={form.resource}
                                                        onChange={handleChange}
                                                        disabled
                                                    >
                                                        <option value="SELLER">SELLER</option>
                                                    </select>
                                                </div>

                                                {/* Name */}
                                                <div className="form-fields-box mb-3">
                                                    <label className="mb-1 fw-bold">Name</label>
                                                    <input
                                                        type="text"
                                                        name="name"
                                                        className={`form-control rounded-0 ${errors.name ? 'is-invalid' : ''}`}
                                                        placeholder="Document type name"
                                                        value={form.name}
                                                        onChange={handleChange}
                                                        maxLength={55}
                                                    />
                                                    {errors.name && <div className="invalid-feedback d-block">{errors.name}</div>}
                                                </div>

                                                {/* Description */}
                                                <div className="form-fields-box mb-3">
                                                    <label className="mb-1 fw-bold">Description</label>
                                                    <textarea
                                                        name="description"
                                                        className="form-control rounded-0"
                                                        rows={3}
                                                        placeholder="Optional description"
                                                        value={form.description || ""}
                                                        onChange={handleChange}
                                                    />
                                                </div>

                                                {/* Status */}
                                                <div className="form-fields-box mb-3">
                                                    <label className="mb-1 fw-bold">Status</label>
                                                    <select
                                                        name="status"
                                                        className="form-select rounded-0"
                                                        value={form.status}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="ACTIVE">Active</option>
                                                        <option value="INACTIVE">Inactive</option>
                                                    </select>
                                                </div>

                                                {/* Sides Required */}
                                                {/* <div className="form-fields-box mb-4">
                                                    <label className="mb-1 fw-bold">Sides Required</label>
                                                    <select
                                                        name="sides_required"
                                                        className="form-select rounded-0"
                                                        value={form.sides_required}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="FRONT">Front</option>
                                                        <option value="BACK">Back</option>
                                                        <option value="BOTH">Both</option>
                                                    </select>
                                                </div> */}

                                                <div className="button-box">
                                                    <button type="submit" className="btn btn-theme w-100" disabled={loading}>
                                                        {loading ? <Spinner /> : "Update Document Type"}
                                                    </button>
                                                </div>
                                            </form>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default EditDocumentType;